import { Network } from '../../../utils/network'

import urls from './urls.json'

async function resolveCarrier(data) {
  const response = await sendRequest(data)
  const parsedResponse = parseResponse(response)
  return parsedResponse
}

async function sendRequest(data) {
  let url = urls.carrierMapper
  url = url.replace(/{phone}/, data.phone)
  const response = await Network.sendGetRequest(url)
  return response
}

function parseResponse(response) {
  if (
    response &&
    (response.status.code === 200 || response.status.code === 201)
  ) {
    const data = {
      success: response.response.isValid,
      operator: response.response.operator,
      logo: response.response.logo || '',
      nationalFormat: response.response.nationalFormat,
      internationalFormat: response.response.internationalFormat,
      fullPhoneNumber: response.response.fullPhoneNumber,
    }
    return data
  }
  if (response.status.code === 0) {
    return {
      success: false,
      message: "Nous n'arrivons pas à contacter internet, veuillez réessayer",
      networkError: true,
    }
  }
  return {
    success: false,
    message:
      response?.response?.message ||
      "Désolé, une erreur s'est produite, veuilez réessayer",
  }
}

export { resolveCarrier }
